import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import useTextStyle from '../TemplateTextStyle';

const TextTag = ({ text, onRemove }) => {
    const classes = useTextStyle();

    return (
        <span className={classes.root} tabIndex={0}>
            {text}
            <span className={classes.actions}>
                <FontAwesomeIcon
                    className={classes.icon}
                    icon='times'
                    data-test-id='template-text-remove-button'
                    onFocus={(e) => e.stopPropagation()}
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                />
            </span>
        </span>
    );
};

TextTag.propTypes = {
    text: PropTypes.string,
    onRemove: PropTypes.func,
};

export default TextTag;
